const trustItems = [
  {
    icon: 'ri-shield-check-line',
    label: 'Trusted Sellers',
    description: 'Geprüfte & verifizierte Verkäufer',
  },
  {
    icon: 'ri-image-line',
    label: 'QC Bilder',
    description: 'Qualitätskontrolle vor Versand',
  },
  {
    icon: 'ri-bank-card-line',
    label: 'Safe Payment',
    description: 'Sichere Zahlungsmethoden',
  },
  {
    icon: 'ri-ship-line',
    label: 'DE Shipping',
    description: 'Versand direkt nach Deutschland',
  },
  {
    icon: 'ri-shield-user-line',
    label: 'Buyer Protection',
    description: 'Umfassender Käuferschutz',
  },
];

export default function TrustBadges() {
  return (
    <section className="w-full py-16 md:py-20 bg-foreground-900">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-accent-400 mb-3 font-[family-name:var(--font-label)]">
            Vertrauen & Sicherheit
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 italic">
            Warum unser Spreadsheet vertrauen?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {trustItems.map((item) => (
            <div
              key={item.label}
              className="rounded-xl bg-foreground-800/40 p-6 text-center hover:bg-foreground-800/60 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-3xl text-accent-400`}></i>
              </div>
              <h3 className="text-sm font-semibold text-background-50 mb-2 whitespace-nowrap font-[family-name:var(--font-label)]">
                {item.label}
              </h3>
              <p className="text-xs text-foreground-300 font-[family-name:var(--font-body)]">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}